import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from './../../Redux/Actions/app';
import styled, { keyframes } from 'styled-components'
import { Headline3, Overline2, Headline5,  Next, ButtonContainer } from './../../Components/Common';
import withRouter from './../../Utilities/withRouter'
import IndustryButton from './Components/IndustryButton';
import { Industries, StylableIndustryButton } from '../../Components/Industries';
import PreviewBox from '../../Components/PreviewBox';
import DevicePreview from '../../Components/PreviewBox/DevicePreview';


const IndustryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media (min-width: 768px) and (max-width: 1260px){
        overflow-x: hidden;
        overflow-y: auto;
    }
`;

const Left = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 0;
    min-width: 845px;
    width: auto;
    height: 785px;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    gap: 16px;
    @media (min-width: 319px) and (max-width: 767px) {
        height: unset;
        min-width: unset;
        position: unset;
        justify-content: center;
        flex: 1;
        ${Overline2}{
            font-size: 26px;
        }
        ${Headline3} {
            font-size: 35px;
        }
        ${Headline5}{
            font-size: 15px;
        }
       
    }
    @media (min-width: 768px) and (max-width: 1025px){
        min-width: 404px;
        flex: 1;
        ${Overline2}{
            font-size: 26px;
        }
        ${Headline3}{
            font-size: 35px;
        }
        ${Headline5}{
            font-size: 15px;
        }
    }
    @media (min-width: 1025px) and (max-width: 1360px){
        min-width: 404px;
        flex: 1;
    }
        
`;

const FadeInFrames = keyframes`
    0% {
    opacity: 0;
    transform: translate(0,20px);
    }
    100% {
        opacity: 1;
        transform: translate(0,0);
    }
`;
const IndustryRow = styled.div`
    display: flex;
    width: 788px;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    animation-name: ${FadeInFrames};
    animation-duration: 0.4s;
    animation-fill-mode: backwards;
    flex-wrap: wrap;
    @media (min-width: 319px) and (max-width: 767px) {
        width: auto;
        justify-content: center;
        gap: 10px;
    }
    @media (min-width: 768px) and (max-width: 1025px){
        width: auto;
        min-width: 404px;
        gap: 10px;
    }
    @media (min-width: 1025px) and (max-width: 1360px){
        width: auto;
        min-width: 404px;
    }
`;
const Centered = styled.div`
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: 10px;
    flex-direction: row;
    padding-left: 60px;
    max-width: 1440px;
    margin: 0px auto auto auto;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px) {
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        margin: 0px auto auto auto;
        ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
        }
        
    }
    @media (min-width: 768px) and (max-width: 1025px){
        max-width: 100vw;
        max-height: 100vh;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 0px;
        margin: 0px 0px 0px 0px;
        gap: 0px;
       
    }
    @media (min-width: 1025px) and (max-width: 1360px){
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 0px;
        margin: 0px 0px 0px 0px;
    }

`;
class Step1 extends Component {
    static propTypes = {
        industry: PropTypes.string,
        navigate: PropTypes.func,
        updateField: PropTypes.func
    };
    componentDidMount(){
        window.gtag('event', 'screen_view', {
            'app_name': 'App Creator',
            'screen_name': 'Step 1'
        });
    }
    onIndustryClicked = (e, industry) =>{
        e.preventDefault();
        const { updateField } = this.props;
        updateField('industry', industry);
    }

    render() {
        const { navigate, industry, updateField } = this.props;
        //let industryImage = null;
        let theme = 'light'
        if(industry){
            let index = Industries.findIndex(t => t.id === industry);
            if(index > -1)
                theme = Industries[index].theme;
                //industryImage = Industries[index].preview;
        }
        return (<Centered>
            <Left>
                <IndustryContainer>
                    <Headline3 style={{marginTop: "30px"}}><Overline2>Step 1:</Overline2><br/>Select Your Industry</Headline3>
                    <Headline5>After 15 years of building apps for global customers across various sectors, we have tailored and optimized features for each industry. Select the industry that best fits your business.</Headline5>
                    <IndustryRow>
                        <IndustryButton industry={'Hospitality'} selected={industry === 'Hospitality'} onClick={(e) => this.onIndustryClicked(e, 'Hospitality')} />
                        <IndustryButton industry={'Healthcare'} selected={industry === 'Healthcare'} onClick={(e) => this.onIndustryClicked(e, 'Healthcare')} />
                        <IndustryButton industry={'Retail'} selected={industry === 'Retail'} onClick={(e) => this.onIndustryClicked(e, 'Retail')} />
                        <IndustryButton industry={'Workplace'} selected={industry === 'Workplace'} onClick={(e) => this.onIndustryClicked(e, 'Workplace')} />
                        <IndustryButton industry={'Campus'} selected={industry === 'Campus'} onClick={(e) => this.onIndustryClicked(e, 'Campus')} />
                        <IndustryButton industry={'Advocacy'} selected={industry === 'Advocacy'} onClick={(e) => this.onIndustryClicked(e, 'Advocacy')} />
                        <IndustryButton industry={'Events'} selected={industry === 'Events'} onClick={(e) => this.onIndustryClicked(e, 'Events')} />
                        <IndustryButton industry={'Other'} selected={industry === 'Other'} onClick={(e) => this.onIndustryClicked(e, 'Other')} />
                    </IndustryRow>
                </IndustryContainer>
                <ButtonContainer>
                    <Next onClick={e => { e.preventDefault(); updateField("features", []); navigate('/step-2');}} disabled={!industry}>Next: Features</Next>
                </ButtonContainer>
            </Left>
            <PreviewBox title={industry}>
                {/* {industryImage && <img title='Industry Image' src={industryImage} />} */}
                <DevicePreview industry={industry} theme={theme} />
            </PreviewBox>
        </Centered>);
    }
}
function stateToProps(state){
    return {...state.app};
}
export default connect(stateToProps, actions)(withRouter(Step1));
